module.exports = __webpack_public_path__ + "static/social-2220b0cff962d3d6dae5676dbdcebfa3.jpg";